// extracted by mini-css-extract-plugin
export default {"uploader":"uploader_uploader__dCdpV","uploader__img":"uploader_uploader__img__lFxZR"};